import React from "react";
import { Box, Paper, Stack } from "@mui/material";

import QuestionDisplay from "./QuestionDisplay";

const MultipleChoice = ({ country, handleSubmitAnswer_MC, gameTitle }) => {
  const renderChoices = (country) => {
    return country.mcChoices.map((choice, idx) => {
      return (
        <Paper
          elevation={3}
          id={choice.correct ? "correct" : ""}
          key={idx}
          sx={{
            padding: "8px",
            textAlign: "center",
            cursor: "pointer",
            backgroundColor: "#fcfff3",
            "&:hover": {
              backgroundColor: "background.default",
            },
            transition: "all .2s ease",
          }}
          onClick={(e) => handleSubmitAnswer_MC(e.target.innerText, country)}
        >
          {gameTitle === "Flags" ? choice.name : choice.capital}
        </Paper>
      );
    });
  };

  return (
    <>
      {<QuestionDisplay gameTitle={gameTitle} country={country} />}
      <Box
        sx={{ margin: "2rem auto", width: { xs: "90%", md: "70%", lg: "60%" } }}
      >
        <Stack spacing={2}>{renderChoices(country)}</Stack>
      </Box>
    </>
  );
};

export default MultipleChoice;
